import type { ObservedPlayer } from "@pd/shared";

/** Shared movement-lock presentation, independent of the status's source.
 * The wire field retains its original name; Bound is the player-facing name. */
export function isBound(player: Pick<ObservedPlayer, "alive" | "frozenUntil">, tick: number | undefined): boolean {
  return player.alive && tick !== undefined && (player.frozenUntil ?? 0) > tick;
}

/** The heavy windup and Bound share the same icy silhouette palette.
 * Dilation is in sprite pixels, scaled with the actor by the renderer. */
export const ICY_SILHOUETTE_PASSES = [
  { dilation: 8, color: "#75dfff", alpha: 0.3 },
  { dilation: 3, color: "#e5fbff", alpha: 1 },
] as const;

export const FIRE_SILHOUETTE_PASSES = [
  { dilation: 8, color: "#ff722e", alpha: 0.3 },
  { dilation: 3, color: "#ffe59d", alpha: 1 },
] as const;
